import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { CategoryResponse, CategoryWithAppsResponse } from '../models/category.model';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  private readonly apiUrl = environment.baseUrl;
  private readonly clientId = environment.cognitoConfig.userPoolWebClientId;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  private getHttpHeaders(requiresAuth: boolean = false): HttpHeaders | undefined {
    // For public GET requests, don't send ANY headers to avoid CORS preflight
    if (!requiresAuth) {
      return undefined;
    }

    // Only for authenticated requests
    const token = this.authService.idToken;
    if (token && token.trim() !== '') {
      return new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
    }

    return undefined;
  }

  getAdminCategories(): Observable<CategoryResponse> {
    const headers = this.getHttpHeaders(true); // Admin endpoint requires auth
    const httpOptions = headers ? { headers } : {};

    return this.http.get<CategoryResponse>(`${this.apiUrl}/category/admin`, httpOptions);
  }

    // New method for front-end categories with apps (public - no auth required)
  getCategoriesWithApps(): Observable<any> {
    const headers = this.getHttpHeaders(false); // Public endpoint - NO headers
    const httpOptions = headers ? { headers } : {};

    return this.http.get<any>(
      `${this.apiUrl}/category/front`, 
      httpOptions
    );
  }

  // Get category with its subcategories (public - no auth required)
  getCategoryWithSubcategories(categoryId: string): Observable<any> {
    const headers = this.getHttpHeaders(false); // Public endpoint - NO headers
    const httpOptions = headers ? { headers } : {};

    return this.http.get<any>(
      `${this.apiUrl}/category/${categoryId}`, 
      httpOptions
    );
  }

  // Get apps by subcategory (public - no auth required)
  getAppsBySubcategory(subCategoryId: string): Observable<any> {
    const headers = this.getHttpHeaders(false); // Public endpoint - NO headers
    const httpOptions = headers ? { headers } : {};

    return this.http.get<any>(
      `${this.apiUrl}/apps/subcategory/${subCategoryId}`, 
      httpOptions
    );
  }
}
